(function () {
  function initBundleBuilder(root) {
    var sectionId = root.id.replace('bb-', '');
    var config = (window.bbSectionData && window.bbSectionData[sectionId]) || {};

    var stepNavItems = Array.prototype.slice.call(root.querySelectorAll('.bb-step-nav-item'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('.bb-panel'));
    var stepOrder = stepNavItems.map(function (item) { return item.dataset.step; });

    var selectedListEl = document.getElementById('bb-selected-list-' + sectionId);
    var itemCountEl = document.getElementById('bb-item-count-' + sectionId);
    var totalEl = document.getElementById('bb-total-' + sectionId);
    var primaryBtn = document.getElementById('bb-add-to-cart-' + sectionId); // same button, dynamic role
    var clearBtn = document.getElementById('bb-clear-' + sectionId);
    var statusEl = document.getElementById('bb-status-' + sectionId);
    var stepErrorEl = document.getElementById('bb-step-error-' + sectionId);

    // state: { variantId: { title, price (cents), qty, step, image } }
    var selections = {};
    var activeStep = stepOrder[0];

    function formatMoney(cents) {
      if (window.Shopify && Shopify.formatMoney) {
        try { return Shopify.formatMoney(cents, config.moneyFormat); } catch (e) {}
      }
      return '$' + (cents / 100).toFixed(2);
    }

    function stepQtyTotal(step) {
      var total = 0;
      Object.keys(selections).forEach(function (id) {
        if (selections[id].step == step) total += selections[id].qty;
      });
      return total;
    }

    function isStepComplete(step) {
      return stepQtyTotal(step) >= 1;
    }

    function allStepsComplete() {
      return stepOrder.every(isStepComplete);
    }

    function stepLabel(step) {
      var item = stepNavItems[stepOrder.indexOf(step)];
      var labelEl = item && item.querySelector('.bb-step-label');
      return labelEl ? labelEl.textContent : '';
    }

    function showStep(step) {
      activeStep = step;
      stepErrorEl.textContent = '';
      stepNavItems.forEach(function (item) {
        item.classList.toggle('active', item.dataset.step === step);
      });
      panels.forEach(function (panel) {
        panel.classList.toggle('active', panel.dataset.step === step);
      });
      render();
    }

    function tryGoToStep(targetStep) {
      var targetIndex = stepOrder.indexOf(targetStep);
      // every step before the target must have at least 1 item selected
      for (var i = 0; i < targetIndex; i++) {
        if (!isStepComplete(stepOrder[i])) {
          var blockingItem = stepNavItems[i];
          var label = blockingItem.querySelector('.bb-step-label').textContent;
          stepErrorEl.textContent = 'Please select at least 1 item in "' + label + '" before continuing.';
          showStep(stepOrder[i]);
          return;
        }
      }
      showStep(targetStep);
    }

    stepNavItems.forEach(function (item) {
      item.addEventListener('click', function () {
        tryGoToStep(item.dataset.step);
      });
    });

    function render() {
      var ids = Object.keys(selections).filter(function (id) { return selections[id].qty > 0; });
      var totalCents = 0;
      var totalItems = 0;

      selectedListEl.innerHTML = '';
      ids.forEach(function (id) {
        var s = selections[id];
        totalCents += s.price * s.qty;
        totalItems += s.qty;

        var row = document.createElement('div');
        row.className = 'bb-selected-row';

        var imgHtml = s.image
          ? '<img src="' + s.image + '" alt="" class="bb-selected-row-img" loading="lazy">'
          : '<div class="bb-selected-row-img bb-selected-row-img--empty"></div>';

        row.innerHTML =
          '<div class="bb-selected-row-media">' + imgHtml + '</div>' +
          '<div class="bb-selected-row-info">' +
            '<span class="bb-selected-row-name">' + s.title + '</span>' +
            '<span class="bb-selected-row-meta">Qty: ' + s.qty + ' &times; ' + formatMoney(s.price) + '</span>' +
          '</div>' +
          '<button type="button" class="bb-selected-row-remove" aria-label="Remove item">' +
            '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' +
              '<path d="M4 7h16M9 7V4a1 1 0 011-1h4a1 1 0 011 1v3m2 0v13a1 1 0 01-1 1H8a1 1 0 01-1-1V7h10z" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>' +
            '</svg>' +
          '</button>';

        var removeBtn = row.querySelector('.bb-selected-row-remove');
        removeBtn.addEventListener('click', function () {
          selections[id].qty = 0;
          render();
        });

        selectedListEl.appendChild(row);
      });

      itemCountEl.textContent = totalItems;
      totalEl.textContent = formatMoney(totalCents);

      // ---- Single dynamic CTA button (same button, changes role per step) ----
      var activeIndex = stepOrder.indexOf(activeStep);
      var isLastStep = activeIndex === stepOrder.length - 1;
      var currentStepDone = isStepComplete(activeStep);

      if (!isLastStep) {
        var nextStep = stepOrder[activeIndex + 1];
        primaryBtn.dataset.mode = 'next';
        primaryBtn.textContent = stepLabel(nextStep);
        primaryBtn.disabled = !currentStepDone;
      } else {
        primaryBtn.dataset.mode = 'checkout';
        primaryBtn.textContent = 'Checkout Bundle';
        primaryBtn.disabled = totalItems === 0 || !allStepsComplete();
      }

      // reflect qty controls + selected state (no max cap)
      root.querySelectorAll('.bb-product-card').forEach(function (card) {
        var variantId = card.dataset.variantId;
        var qty = (selections[variantId] && selections[variantId].qty) || 0;
        var qtyControl = card.querySelector('.bb-qty-control');
        var qtyValueEl = card.querySelector('.bb-qty-value');

        qtyControl.dataset.qty = qty;
        qtyValueEl.textContent = qty;
        card.classList.toggle('bb-selected', qty > 0);
      });

      // mark completed steps with a tick (skip the currently active one)
      stepNavItems.forEach(function (item) {
        var step = item.dataset.step;
        var complete = isStepComplete(step);
        item.classList.toggle('completed', complete && step !== activeStep);
      });
    }

    root.querySelectorAll('.bb-product-card').forEach(function (card) {
      var variantId = card.dataset.variantId;
      var step = card.dataset.step;
      var plusBtn = card.querySelector('.bb-qty-plus');
      var minusBtn = card.querySelector('.bb-qty-minus');

      if (!selections[variantId]) {
        selections[variantId] = {
          title: card.dataset.title,
          price: parseInt(card.dataset.price, 10),
          qty: 0,
          step: step,
          image: card.dataset.image
        };
      }

      plusBtn.addEventListener('click', function () {
        selections[variantId].qty += 1;
        render();
      });

      minusBtn.addEventListener('click', function () {
        if (selections[variantId].qty > 0) selections[variantId].qty -= 1;
        render();
      });
    });

    clearBtn.addEventListener('click', function () {
      Object.keys(selections).forEach(function (id) { selections[id].qty = 0; });
      statusEl.textContent = '';
      render();
    });

    // Single button: behaves as "Choose <Next Step>" or "Checkout Bundle" depending on primaryBtn.dataset.mode
    primaryBtn.addEventListener('click', function () {
      if (primaryBtn.dataset.mode === 'next') {
        var activeIndex = stepOrder.indexOf(activeStep);
        var nextStep = stepOrder[activeIndex + 1];
        if (nextStep) tryGoToStep(nextStep);
        return;
      }

      // mode === 'checkout' -> existing add-to-cart flow
      if (!allStepsComplete()) return;

      var items = Object.keys(selections)
        .filter(function (id) { return selections[id].qty > 0; })
        .map(function (id) { return { id: parseInt(id, 10), quantity: selections[id].qty }; });

      if (!items.length) return;

      primaryBtn.disabled = true;
      statusEl.textContent = 'Adding to cart...';
      statusEl.className = 'bb-status-msg';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (res) {
          return res.json().then(function (data) {
            if (!res.ok) throw new Error(data.description || data.message || 'Add to cart failed');
            return data;
          });
        })
        .then(function () {
          document.dispatchEvent(new CustomEvent('bb:cart-updated'));

          if (!config.stayOnPage) {
            statusEl.textContent = 'Redirecting to checkout...';
            statusEl.className = 'bb-status-msg success';
            window.location.href = '/checkout';
            return;
          }

          statusEl.textContent = 'Added to cart!';
          statusEl.className = 'bb-status-msg success';
          Object.keys(selections).forEach(function (id) { selections[id].qty = 0; });
          showStep(stepOrder[0]);
          primaryBtn.disabled = false;
        })
        .catch(function (err) {
          statusEl.textContent = err.message;
          statusEl.className = 'bb-status-msg error';
          primaryBtn.disabled = false;
        });
    });

    render();
  }

  document.querySelectorAll('.bb-wrapper').forEach(initBundleBuilder);
})();
